"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationErrorHandler = void 0;
class OperationErrorHandler {
    static getTryCatchFinallyHook(_ctx) {
        return this;
    }
    static onCatch(ctx) {
        const dArgs = ctx.decoratorArgs;
        ctx.error = this.wrap(ctx.error, () => {
            dArgs?.onError?.apply(this, [ctx]);
            return ctx.error;
        }, ctx);
    }
    static wrap(originalError, getWrapper, ctx) {
        const wrapper = getWrapper(originalError);
        if (wrapper && originalError !== wrapper)
            wrapper.underlyingError = originalError;
        const trackedError = wrapper;
        if (!trackedError)
            return;
        if (!ctx)
            return;
        if (!trackedError.trackedContext)
            trackedError.trackedContext = ctx;
        const trackedContextProp = Object.getOwnPropertyDescriptor(trackedError, 'trackedContext');
        if (trackedContextProp?.enumerable) {
            trackedContextProp.enumerable = false;
            Object.defineProperty(trackedError, 'trackedContext', trackedContextProp);
        }
        return wrapper;
    }
}
exports.OperationErrorHandler = OperationErrorHandler;
//# sourceMappingURL=OperationErrorHandler.js.map